var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.allMessages)?_c(_setup.EmailLog,{on:{"switch":function($event){_setup.allMessages = $event}}}):_c(_setup.EmailCustomers,{on:{"switch":function($event){_setup.allMessages = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }